// 官网提示说明（非表单）
export default {
  暂无相关的招标: 'No relevant tenders yet.',
  发布于: 'Published on',
  阅读: 'Total Views',
  发布日期: 'Posted on',
  该招标已下架: 'Tender removed.',
  该招标不存在: "Tender doesn't exist.",
}
